module.exports = __webpack_public_path__ + "static/media/pirateShip.4fd4cd62.png";